<script lang="ts">
    import Button from "../materialize/components/Button.svelte";
    import Icon from "../materialize/components/Icon.svelte";
    function sendmail() {
        if (AndroidInterface.send_email(mail_to, mail_subject, mail_body)) {
            M.toast({ html: "Grazie per averci contattato" });
        }
    }
    export let mail_to: string = "info@approu.it";
    export let mail_subject: string = "";
    export let mail_body: string = "";

    export let button_flat: boolean = false;
    export let button_text: string = "";
    export let class_list: string[] = [];

    function generate_href_mail() : string{
        if (mail_subject || mail_body)
        {
            let subj_part = encodeURIComponent(mail_subject);
            let body_part = encodeURIComponent(mail_body);
            return "?"+[subj_part, body_part].join("&");
        }
        else
        {
            return "";
        }
    }
</script>

{#if window.hasOwnProperty("AndroidInterface") && AndroidInterface.send_email}
    <Button {class_list} flat={button_flat} on:click={sendmail}>
        {button_text}
        <Icon class_list={["right"]} icon="email" />
    </Button>
{:else}
    <Button
    href={`mailto:${mail_to}${generate_href_mail()}`}
    {class_list} flat={button_flat}>
        {button_text}
        <Icon class_list={["right"]} icon="email" />
    </Button>
{/if}
